import React from "react";
import styles from "../Legal/legal.module.css";
import { Link } from "react-router-dom";
import MetaTags from "../../components/MetaTags";


const PrivacyPolicy = () => {
  return (
    <>
     <MetaTags
     title="Privacy Policy - Ninjascode"
     description="Privacy policy of Ninjascode"
     />
    <section className={styles.legal}>
      <div className={styles.container}>
        <h1>Privacy Policy</h1>
        <div className={styles.content}>
          <h2>INTRODUCTION</h2>
          <p>
            NINJAS CODE ("Company", “our” or "We") respect your privacy and are
            committed to protecting it through our compliance with this policy.
            This policy describes the types of information we may collect from
            you or that you may provide when you visit the{" "}
            <Link to="/">website</Link>. Please read this policy carefully to
            understand our policies and practices regarding your information and
            how we will treat it. If you do not agree with our policies and
            practices, your choice is not to use our Website. By accessing or
            using this Website, you agree to this privacy policy. This policy
            may change from time to time. Your continued use of this Website
            after we make changes is deemed to be acceptance of those changes,
            so please check the policy periodically for updates.
          </p>

          <h2>PURPOSES OF PROCESSING</h2>
          <h3>What is Personal Data?</h3>
          <p>
            We collect various forms of information about you, including
            personal data. As defined by the General Data Protection Regulation
            (GDPR), "personal data" refers to any information that, either alone
            or in combination with other information we process about you,
            identifies you as an individual. This includes, for example, your
            name, postal address, email address, and telephone number.
          </p>

          <h3>Why Do We Need Your Personal Data?</h3>
          <p>
            We process your personal data in accordance with applicable data
            protection and privacy laws. Certain personal data is necessary to
            provide you with access to our Website. When you register with us,
            you will be asked to agree to provide this information in order to
            access our services, purchase our products, or view our content.
            This consent gives us the legal basis required under applicable law
            to process your data. You have the right to withdraw your consent at
            any time. If you do not agree to our use of your personal data as
            outlined in this Policy, please refrain from using our Website.
          </p>

          <h3>This policy applies to information we collect:</h3>

          <ul>
            <li>On our Website.</li>
            <li>
              In email, text, and other electronic messages between you and our
              Website.
            </li>
            <li>
              Through mobile and desktop applications you download from our
              Website, which provide dedicated non-browser-based interaction
              between you and our Website.
            </li>
            <li>
              When you interact with our advertising and applications on
              third-party websites and services, if those applications or
              advertising include links to this policy.
            </li>
          </ul>

          <h3>It does not apply to information collected by:</h3>
          <ul>
            <li>
              Us offline or through any other means, including on any other
              website operated by Company or any third party (including our
              affiliates and subsidiaries); or{" "}
            </li>
            <li>
              Any third party (including our affiliates and subsidiaries),
              including through any application or content (including
              advertising) that may link to or be accessible from or through the
              Website.
            </li>
          </ul>

          <h3>Information we collect</h3>
          <p>We may collect the following types of information:</p>
          <p>Personal Information:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Job title</li>
            <li>Company name</li>
            <li>Address</li>
          </ul>

          <p>Non-Personal Information:</p>
          <ul>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Referring site</li>
            <li>Pages visited</li>
            <li>Time and date of visit</li>
            <li>IP address</li>
          </ul>

          <h3>How We Use Your Information</h3>
          <p>
            We use the information we collect to provide, operate, and maintain
            our website, as well as to improve, personalize, and expand it.
            Understanding and analyzing how you use our website helps us develop
            new products, services, features, and functionality. We communicate
            with you directly or through our partners for customer service,
            updates, marketing, and promotional purposes. Additionally, we
            process your transactions, manage your orders, send you emails, and
            work to find and prevent fraud.
          </p>

          <h3>Artificial Intelligence (AI) models We Utilize </h3>
          <p>
            We use certain Artificial Intelligence models to address your
            queries. Services like ChatGPT or other Artificial Intelligence
            models generate responses by reading a user’s request and, in
            response, predicting the words most likely to appear next. In some
            cases, the words most likely to appear next may not be the most
            factually accurate. For this reason, you should not rely on the
            factual accuracy of output from our models. Given the technical
            complexity of how our models work, we may not be able to correct the
            inaccuracy in every instance. In your conversations with any AI
            model, you may choose to provide sensitive information; by providing
            such sensitive information, you consent to our use of it for the
            purposes set out in this Privacy Policy. If you choose to provide
            sensitive personal information in your messages and content, we will
            use that information only to facilitate your conversation with the
            AI model. If you do not want us to process your sensitive
            information for these purposes, please do not provide it. In some
            circumstances you can ask us to delete your data. In some
            circumstances we may anonymize your personal data (so that it can no
            longer be associated with you) for research or statistical purposes
            in which case we may use this information indefinitely without
            further notice to you.
          </p>

          <h2>COLLECTING YOUR PERSONAL DATA</h2>
          <p>
            We collect several types of information from and about users of our
            Website, including information:
          </p>

          <h3>Social Networking Sites</h3>
          <p>
            Information from Social Networking Sites (the <b>“SNS”</b>). Our
            website includes interfaces that allow you to connect with social
            networking sites. If you connect to a SNS through our website, you
            authorize us to access, use and store the information that you
            agreed the SNS could provide to us based on your settings on that
            SNS. We will access, use and store that information in accordance
            with this Policy. You can revoke our access to the information you
            provide in this way at any time by amending the appropriate settings
            from within your account settings on the applicable SNS.
          </p>

          <h3>Information Automatically Collected</h3>
          <p>
            We automatically log information about you and your computer or
            mobile device when you access our website. For example, when
            visiting our website, we log your computer or mobile device
            operating system name and version, manufacturer and model, browser
            type, browser language, screen resolution, the website you visited
            before browsing to our website, pages you viewed, how long you spent
            on a page, access times and information about your use of and
            actions on our website. We collect this information about you using
            cookies. Automated Decision Making and Profiling.We do not use your
            personal data for the purposes of automated decision-making.
            However, we may do so in order to fulfill obligations imposed by
            law, in which case we will inform you of any such processing and
            provide you with an opportunity to object.
          </p>

          <h3>Cookies</h3>
          <p>
            We may collect information using “cookies.” Cookies are small data
            files stored on the hard drive of your computer or mobile device by
            a website. We may use both session cookies (which expire once you
            close your web browser) and persistent cookies (which stay on your
            computer or mobile device until you delete them) to provide you with
            a more personal and interactive experience on our website. We use
            two broad categories of cookies: (1) first party cookies, served
            directly by us to your computer or mobile device, which are used
            only by us to recognize your computer or mobile device when it
            revisits our website; and (2) third party cookies, which are served
            by service providers on our website, and can be used by such service
            providers to recognize your computer or mobile device when it visits
            other websites. Our website uses the following types of cookies for
            the purposes set out below:
          </p>

          <h4>Essential Cookies</h4>
          <p>
            These cookies are essential to provide you with services available
            through our website and to enable you to use some of its features.
            For example, they allow you to log in to secure areas of our website
            and help the content of the pages you request load quickly. Without
            these cookies, the services that you have asked for cannot be
            provided, and we only use these cookies to provide you with those
            services.
          </p>

          <h4>Functionality Cookies</h4>
          <p>
            These cookies allow our website to remember choices you make when
            you use our website, such as remembering your language preferences,
            remembering your login details and remembering the changes you make
            to other parts of our website which you can customize. The purpose
            of these cookies is to provide you with a more personal experience
            and to avoid you having to re-enter your preferences every time you
            visit our website.
          </p>

          <h4>Analytics and Performance Cookies</h4>
          <p>
            These cookies are used to collect information about traffic to our
            website and how users use our website. The information gathered does
            not identify any individual visitor. It includes the number of
            visitors to our website, the websites that referred them to our
            website, the pages they visited on our website, what time of day
            they visited our website, whether they have visited our website
            before, and other similar information. We use this information to
            help operate our website more efficiently, to gather broad
            demographic information and to monitor the level of activity on our
            website. We use Google Analytics and Mixpanel for this purpose.
            Google Analytics uses its own cookies. It is only used to improve
            how our website works. You can find out more information about
            Google Analytics cookies here:{" "}
            <a
              href="https://developers.google.com/analytics/resources/concepts/gaConceptsCookies"
              target="_blank"
            >
              Google Analytics Cookie Usage
            </a>
            You can find out more about how Google protects your data here:{" "}
            <a href="https://policies.google.com/privacy" target="_blank">
              Google Privacy Policy
            </a>
            You can prevent the use of Google Analytics relating to your use of
            our website by downloading and installing the browser plugin
            available via this link:{" "}
            <a
              href="http://tools.google.com/dlpage/gaoptout?hl=en-GB"
              target="_blank"
            >
              Google Analytics Opt-out Browser Add-on
            </a>
          </p>

          <h4>Targeted and Advertising Cookies</h4>
          <p>
            These cookies track your browsing habits to enable us to show
            advertising which is more likely to be of interest to you. These
            cookies use information about your browsing history to group you
            with other users who have similar interests. Based on that
            information, and with our permission, third party advertisers can
            place cookies to enable them to show adverts which we think will be
            relevant to your interests while you are on third party websites.
            You can disable cookies which remember your browsing habits and
            target advertising at you by visiting{" "}
            <a
              href="http://www.youronlinechoices.com/uk/your-ad-choices"
              target="_blank"
            >
              Your Ad Choices.
            </a>{" "}
            If you choose to remove targeted or advertising cookies, you will
            still see adverts but they may not be relevant to you. Even if you
            do choose to remove cookies by the companies listed at the above
            link, not all companies that serve online behavioral advertising are
            included in this list, and so you may still receive some cookies and
            tailored adverts from companies that are not listed.
          </p>

          <h4>Social Media Cookies</h4>
          <p>
            These cookies are used when you share information using a social
            media sharing button or “like” button on our website or you link
            your account or engage with our content on or through a social
            networking website such as Facebook, Twitter or Google+. The social
            network will record that you have done this.
          </p>

          <h4>Disabling cookies</h4>
          <p>
            You can typically remove or reject cookies via your browser
            settings. In order to do this, follow the instructions provided by
            your browser (usually located within the “settings,” “help” “tools”
            or “edit” facility). Many browsers are set to accept cookies until
            you change your settings. If you do not accept our cookies, you may
            experience some inconvenience in your use of our website. For
            example, we may not be able to recognize your computer or mobile
            device and you may need to log in every time you visit our website.
          </p>

          <h2>ADVERTISING</h2>
          <p>
            We may use other companies to serve third-party advertisements when
            you visit and use the website. These companies may collect and use
            click stream information, browser type, time and date, subject of
            advertisements clicked or scrolled over during your visits to the
            website and other websites in order to provide advertisements about
            goods and services likely to be of interest to you. These companies
            typically use tracking technologies to collect this information.
            Other companies’ use of their tracking technologies is subject to
            their own privacy policies.
          </p>

          <h2>HOW WE USE YOUR PERSONAL DATA:</h2>
          <p>We may utilize your personal data for the following purposes:</p>
          <ul>
            <li>
              <b>Website and Service Enhancement:</b> To operate, maintain, and
              improve our website, products, and services.
            </li>
            <li>
              <b>Account Management:</b> To manage your account, including
              communication related to your account if you have one on our
              website.
            </li>
            <li>
              <b>Rewards and Promotions Administration:</b> To operate and
              administer rewards programs and other promotions you participate
              in on our website.
            </li>
            <li>
              <b>Customer Support:</b> To respond to your comments and questions
              and to provide customer service.
            </li>
            <li>
              <b>Notifications and Updates:</b> To send information such as
              technical notices, updates, security alerts, and support and
              administrative messages.
            </li>
            <li>
              <b>Marketing Communications:</b> With your consent, to send you
              marketing emails about upcoming promotions and other news,
              including information about products and services offered by us
              and our affiliates. You may opt out of receiving such
              communications at any time; instructions on how to opt out are
              included in the marketing emails. Note that even if you opt out of
              marketing emails, we may still send you non-marketing emails, such
              as those related to your account or our business dealings with
              you.
            </li>
            <li>
              <b>Payment Processing:</b> To process payments you make via our
              website.
            </li>
            <li>
              <b>Legal Compliance:</b> To comply with applicable laws, lawful
              requests, and legal processes, including responses to public and
              governmental authorities. To enforce our policies and protect our
              rights, privacy, safety, or property, as well as yours or others'.
            </li>
            <li>
              <b>Analysis and Research:</b> For analysis and study services to
              better understand and improve our offerings.
            </li>
            <li>
              <b>Data Sharing:</b> As described in the “Sharing of Your Personal
              Data” section below.
            </li>
          </ul>

          <h2>SHARING YOUR PERSONAL DATA</h2>
          <p>We may share your personal data in the following ways:</p>
          <ul>
            <li>
              <strong>With Third Parties Designated by You:</strong>
              We may share your personal data with third parties when you have
              provided your consent to do so.
            </li>
            <li>
              <strong>With Our Third-Party Service Providers:</strong>
              We may share your personal data with our third-party service
              providers who offer services such as data analysis, payment
              processing, information technology and related infrastructure
              provision, customer service, email delivery, auditing, and other
              similar services.
            </li>
            <li>
              <strong>With Third-Party Sites:</strong>
              Our website may contain links to third-party websites and
              features. This Policy does not cover the privacy practices of
              these third parties. These third parties have their own privacy
              policies, and we do not accept any responsibility or liability for
              their websites, features, or policies. Please review their privacy
              policies before submitting any data to them.
            </li>
          </ul>

          <h2>OUR POLICY ON CHILDREN</h2>

          <p>
            Our website is not intended for use by children under the age of 16.
            If you are a parent or guardian and become aware that your child has
            provided us with personal information without your consent, please
            contact us immediately. We will promptly take steps to delete such
            information from our records in a timely manner.
          </p>

          <h2>YOUR RIGHTS</h2>
          <p>You have the following rights regarding your personal data:</p>

          <ul>
            <li>
              <strong>Opt-out:</strong> You may contact us at any time to
              opt-out of:
              <ul>
                <li>Direct marketing communications</li>
                <li>Automated decision-making and/or profiling</li>
                <li>Our collection of sensitive personal data</li>
                <li>
                  Any new processing of your personal data beyond the original
                  purpose
                </li>
                <li>The transfer of your personal data outside the EEA</li>
              </ul>
              Please note that opting out may affect the functionality of some
              aspects of our website.
            </li>
            <li>
              <strong>Access:</strong> You can access the information we hold
              about you at any time via your profile/account or by contacting us
              directly.
            </li>
            <li>
              <strong>Amend:</strong> You can contact us to update or correct
              any inaccuracies in your personal data.
            </li>
            <li>
              <strong>Move:</strong> Your personal data is portable, allowing
              you to move your data to other service providers as you wish.
            </li>
            <li>
              <strong>Erase and Forget:</strong> In certain situations, such as
              when the information we hold about you is no longer relevant or is
              incorrect, you can request that we erase your data.
            </li>
          </ul>
          <p>
            If you wish to exercise any of these rights, please contact us. In
            your request, please specify:
          </p>
          <ul>
            <li>The personal data concerned</li>
            <li>Which of the above rights you would like to enforce</li>
          </ul>
          <p>
            For your protection, we will only implement requests with respect to
            the personal data associated with the email address used to send the
            request. We may need to verify your identity before implementing
            your request. We will try to comply with your request as soon as
            reasonably practicable, and in any event, within one month of your
            request.
          </p>
          <p>
            Please note that we may need to retain certain information for
            record-keeping purposes and/or to complete any transactions that you
            began prior to requesting such changes or deletion.
          </p>

          <h2>
            INFORMATION WE COLLECT THROUGH AUTOMATIC DATA COLLECTION
            TECHNOLOGIES
          </h2>
          <p>
            As you navigate through and interact with our Website, we may use
            automatic data collection technologies to collect certain
            information about your equipment, browsing actions, and patterns,
            including:
          </p>
          <ul>
            <li>
              Details of your visits to our Website, including [traffic data,]
              [location data,] [logs,] and other communication data and the
              resources that you access and use on the Website.
            </li>
            <li>
              Information about your computer and internet connection, including
              your IP address, operating system, and browser type.
            </li>
          </ul>
          <p>
            We also may use these technologies to collect information about your
            online activities over time and across third-party websites or other
            online services (behavioral tracking).
          </p>
          <p>
            The information we collect automatically may include personal
            information, but we may maintain it or associate it with personal
            information we collect in other ways or receive from third parties.
            It helps us to improve our Website and to deliver a better and more
            personalized service, including by enabling us to:
          </p>
          <ul>
            <li>Estimate our audience size and usage patterns.</li>
            <li>
              Store information about your preferences, allowing us to customize
              our Website according to your individual interests.
            </li>
            <li>Speed up your searches.</li>
            <li>Recognize you when you return to our Website.</li>
          </ul>
          <p>
            The technologies we use for this automatic data collection may
            include:
          </p>
          <ul>
            <li>
              <strong>Cookies (or browser cookies):</strong> A cookie is a small
              file placed on the hard drive of your computer. You may refuse to
              accept browser cookies by activating the appropriate setting on
              your browser. However, if you select this setting you may be
              unable to access certain parts of our Website. Unless you have
              adjusted your browser setting so that it will refuse cookies, our
              system will issue cookies when you direct your browser to our
              Website.
            </li>
            <li>
              <strong>Web Beacons:</strong> Pages of our Website and our emails
              may contain small electronic files known as web beacons (also
              referred to as clear gifs, pixel tags, and single-pixel gifs) that
              permit the Company, for example, to count users who have visited
              those pages and for other related website statistics (for example,
              recording the popularity of certain website content and verifying
              system and server integrity).
            </li>
          </ul>
          <p>
            We do not collect personal information automatically, but we may tie
            non-personal information collected automatically to personal
            information about you that we collect from other sources or that you
            provide to us.
          </p>

          <h2>CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION</h2>
          <p>
            We strive to provide you with choices regarding the personal
            information you provide to us. We have created mechanisms to provide
            you with the following control over your information:
          </p>
          <ul>
            <li>
              <strong>Tracking Technologies and Advertising:</strong>
              You can set your browser to refuse all or some browser cookies, or
              to alert you when cookies are being sent. If you disable or refuse
              cookies, please note that some parts of this site may then be
              inaccessible or not function properly.
            </li>
            <li>
              <strong>
                Disclosure of Your Information for Third-Party Advertising:
              </strong>
              If you do not want us to share your personal information with
              unaffiliated or non-agent third parties for promotional purposes,
              you can opt-out by sending us an email with your request to{" "}
              <a
                href="mailto:info@ninjascode.com"
                rel="noreferrer"
                target="_blank"
              >
                info@ninjascode.com
              </a>
              .
            </li>
            <li>
              <strong>Targeted Advertising:</strong>
              If you do not want us to use information that we collect or that
              you provide to us to deliver advertisements according to our
              advertisers' target-audience preferences, you can opt-out by
              sending us an email with your request to{" "}
              <a
                href="mailto:info@ninjascode.com"
                rel="noreferrer"
                target="_blank"
              >
                info@ninjascode.com
              </a>
              . For this opt-out to function, you must have your browser set to
              accept all browser cookies.
            </li>
          </ul>
          <p>
            We do not control third parties' collection or use of your
            information to serve interest-based advertising. However, these
            third parties may provide you with ways to choose not to have your
            information collected or used in this way.
          </p>

          <h2>ACCESSING AND CORRECTING YOUR INFORMATION</h2>
          <p>
            You can review and change your personal information by logging into
            the Website and visiting your account profile page. You may also
            send us an email at{" "}
            <a
              href="mailto:info@ninjascode.com"
              rel="noreferrer"
              target="_blank"
            >
              info@ninjascode.com
            </a>{" "}
            to request access to, correct, or delete any personal information
            that you have provided to us. We cannot delete your personal
            information except by also deleting your user account. We may not
            accommodate a request to change information if we believe the change
            would violate any law or legal requirement or cause the information
            to be incorrect. If you delete your User Contributions from the
            Website, copies of your User Contributions may remain viewable in
            cached and archived pages, or might have been copied or stored by
            other Website users. Proper access and use of information provided
            on the Website, including User Contributions, is governed by our{" "}
            <Link to="/terms-conditions">terms of use.</Link>
          </p>

          <h2>USER-GENERATED CONTENT</h2>
          <p>
            When you submit user-generated content to our website, such as
            through our rewards program, forums, message boards, and blogs, you
            may share personal data with us. Please be aware that any
            information you post or disclose on our website becomes public
            information, accessible to other users and the general public. We
            strongly advise you to exercise caution when deciding to disclose
            your personal data or any other information on our website, as it
            will not remain private or confidential once published. If you
            provide feedback to us, we may use and disclose such feedback on our
            website, provided it is not associated with your personal data. With
            your consent, we may post your first and last name alongside your
            feedback. Any personal data contained in your feedback will be
            collected and treated in accordance with this Policy.
          </p>

          <h2>INTERNATIONAL DATA TRANSFER</h2>
          <p>
            Your information, inclusive of personal data gathered from you, may
            be transmitted, stored, and processed by us beyond the borders of
            your residing country, where data protection and privacy regulations
            may not provide an equivalent level of safeguarding as in other
            regions. By consenting to this Policy, you acknowledge and agree to
            such transfer, storage, or processing. We commit to taking all
            reasonable measures to ensure that your data is handled securely and
            in compliance with the provisions outlined in this Policy.
          </p>
          <h2>DATA SECURITY</h2>
          <p>
            We have implemented measures designed to secure your personal
            information from accidental loss and from unauthorized access, use,
            alteration, and disclosure. All information you provide to us is
            stored on our secure servers behind firewalls. Any payment
            transactions will be encrypted.
          </p>
          <p>
            The safety and security of your information also depends on you.
            Where we have given you (or where you have chosen) a password for
            access to certain parts of our Website, you are responsible for
            keeping this password confidential. We ask you not to share your
            password with anyone. We urge you to be careful about giving out
            information in public areas of the Website like message boards. The
            information you share in public areas may be viewed by any user of
            the Website.
          </p>
          <p>
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we do our best to protect your
            personal information, we cannot guarantee the security of your
            personal information transmitted to our Website. Any transmission of
            personal information is at your own risk. We are not responsible for
            circumvention of any privacy settings or security measures contained
            on the Website.
          </p>

          <h2>RETENTION</h2>
          <p>
            We will retain your personal data only for the duration reasonably
            necessary for your utilization of the website, until such time as
            you elect to close your account or terminate your subscription,
            unless a longer retention period is mandated or permissible under
            the law (such as for regulatory compliance purposes).
          </p>

          <h2>COMPLAINTS</h2>
          <p>
            We are dedicated to addressing any grievances regarding the
            collection or utilization of your personal data. Should you wish to
            lodge a complaint concerning this Policy or our practices pertaining
            to your personal data, please reach out to us via the contact
            details provided on our website. We will endeavor to respond to your
            complaint promptly, aiming to do so within 30 days at the latest.
            While we strive to resolve all complaints brought to our attention,
            should you remain dissatisfied with the resolution, you retain the
            right to contact your local data protection supervisory authority.
          </p>

          <h2>CHANGES TO OUR PRIVACY POLICY</h2>
          <p>
            It is our policy to post any changes we make to our privacy policy
            on this page with a notice that the privacy policy has been updated
            on the Website home page. If we make material changes to how we
            treat our users' personal information, we will notify you through a
            notice on the Website home page. The date the privacy policy was
            last revised is identified at the top of the page. You are
            responsible for ensuring we have an up-to-date active and
            deliverable email address for you, and for periodically visiting our
            Website and this privacy policy to check for any changes.
          </p>

          <h2>CONTACT INFORMATION</h2>
          <p>
            To ask questions or comment about this privacy policy and our
            privacy practices, contact us at{" "}
            <a
              href="mailto:info@ninjascode.com"
              rel="noreferrer"
              target="_blank"
            >
              info@ninjascode.com
            </a>{" "}
            or write to us through our Website.
          </p>
        </div>
      </div>
    </section>
    </>
  );
};

export default PrivacyPolicy;
